import { isNumber } from 'lodash/fp';

interface ValidateMaxDecimalsArgs {
    value: number;
    maxDecimals: number | undefined;
}

export const validateMaxDecimals = ({ value, maxDecimals }: ValidateMaxDecimalsArgs) => {
    if (isNumber(maxDecimals)) {
        const [integerPart, decimalPart] = value.toString().split('.');
        if (decimalPart) {
            const slicedDecimalPart = decimalPart.slice(0, maxDecimals);
            return parseFloat(`${integerPart}.${slicedDecimalPart}`);
        }

        return parseFloat(integerPart);
    }

    return value;
};
